import { useRef, useEffect } from 'react';
/**
 * Эффект вызываемый после первого рендера.
 */
export var useUpdateEffect = function (fn, deps) {
    var isMount = useRef(true);
    useEffect(function () {
        if (isMount.current) {
            isMount.current = false;
        }
        else {
            fn();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deps]);
};
